import React from 'react'
import ReactDOM from 'react-dom'

import './About.scss'
import AOS from 'aos';
import 'aos/dist/aos.css';

import Typed from 'typed.js';

// var typed = new Typed('#typed', {
//   startDelay: 1000,
//   strings: [],
//   smartBackspace: true,
//   typeSpeed: 60,
//   backSpeed: 25,
//   backDelay: 2500,
//   shuffle: false,
//   // onComplete: (self) => {
//   // 	document.getElementById("runBtn").style.display = "block";
//   // },
// });

AOS.init();
export default function About() {
  const el = React.useRef(null);

  React.useEffect(() => {
    const typed = new Typed(el.current, {
      startDelay: 1000,
      smartBackspace: true,
      typeSpeed: 40,
      backSpeed: 25,
      backDelay: 2500,
      shuffle: false,
      strings: [
        "Sheed Netlify [Version 7.16.2023]<br>\
        (c) 2023 Sheed. All rights reserved.<br>\
        >> Kumusta! My name is Rasheed<br>\
        >> You can call me Sheed<br>\
        >> Thank you for visiting my portfolio :D",
      ],
      // typeSpeed: 50,
      // onStringTyped: (arrayPos, self) => {
      //   // Called after each string is typed
      //   console.log(`>> ${arrayPos}`);
      // }
    });

    return () => {
      typed.destroy();
    };
  }, []);

  return (
    <>
      <div className="content layers row" id="about">

        <div className='col-lg-6 col-md-12 col-sm-12 about-left about-description'>
          <div id="ide" className="ide" data-aos="fade-up">
            <div className="ideHeader">
              <span className='ide-title'>Kumusta.js</span>
              <div className="ideButtons">
                <div className="minimizeBtn"></div>
                <div className="restoreBtn"></div>
                <div className="closeBtn"></div>
              </div>
            </div>
            <div class='ideBody'>

              <span id="el" ref={el}>
              </span>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-12 col-sm-12 about-right">
          <div class="section-title-div">
            <h3 className='div-title'><span>A</span>BOUT</h3>
            <div class="div-centered-text">
              Kumusta</div>
          </div>
          <div>

            {/* <p className='header'></p> */}
            <div className='description'>
              <p>Currently senior-level student taking Computer Science at the University of the East, Manila.</p>
              <p>Took Mobile App & Web Development strand which developed projects as a team including a mobile game and a web application using Android Studio and Unity.</p>
              <p>
                Focused and interested in the field of Mobile App and Web Development as Front-End or Back-End, Machine Learning, and Game Development.
              </p>

            </div>
          </div>
        </div>


        {/* "Also highly motivated to join and collaborate on interesting projects preferably in the field of machine learning and web/software development." */}

        {/* <p>Joined at the Impact 2050: Hackathon (2022) with fellow friends from different universities. Didn't have the chance to win the competition but learned a lot from it.</p> */}
      </div >
    </>
  )
}